export default __webpack_public_path__ + "static/media/book_image6.10f40b41.jfif";